/* LumiWhite — interacciones (sin librerías) */
document.documentElement.classList.add('lw-js');

(function () {
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var observer = null;

  function initReveal(root) {
    var els = (root || document).querySelectorAll('.lw-reveal:not(.lw-visible)');
    if (!els.length) return;
    if (reduce || !('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('lw-visible'); });
      return;
    }
    if (!observer) {
      observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (!e.isIntersecting) return;
          e.target.classList.add('lw-visible');
          if (e.target.hasAttribute('data-lw-count')) contar(e.target);
          observer.unobserve(e.target);
        });
      }, { threshold: 0.15, rootMargin: '0px 0px -40px 0px' });
    }
    els.forEach(function (el) { observer.observe(el); });
  }

  function contar(el) {
    var fin = parseFloat(el.getAttribute('data-lw-count')) || 0;
    var decimales = (el.getAttribute('data-lw-count').split('.')[1] || '').length;
    if (reduce) { el.textContent = fin.toFixed(decimales); return; }
    var dur = 1600, t0 = null;
    function paso(t) {
      if (!t0) t0 = t;
      var p = Math.min((t - t0) / dur, 1);
      var v = fin * (1 - Math.pow(1 - p, 3));
      el.textContent = v.toFixed(decimales);
      if (p < 1) requestAnimationFrame(paso);
    }
    requestAnimationFrame(paso);
    // Garantiza el valor final aunque el navegador pause la animación
    setTimeout(function () { el.textContent = fin.toFixed(decimales); }, dur + 300);
  }

  function initContadores(root) {
    (root || document).querySelectorAll('[data-lw-count]').forEach(function (el) {
      if (!el.classList.contains('lw-reveal')) el.classList.add('lw-reveal');
    });
  }

  function initComparador(root) {
    (root || document).querySelectorAll('[data-lw-comp]').forEach(function (comp) {
      var input = comp.querySelector('input[type=range]');
      if (!input || input.dataset.lwOk) return;
      input.dataset.lwOk = '1';
      function pon(v) { comp.style.setProperty('--pos', v + '%'); }
      pon(input.value);
      input.addEventListener('input', function () { pon(input.value); });
    });
  }

  function initParallax(root) {
    var img = (root || document).querySelector('[data-lw-parallax]');
    if (!img || reduce) return;
    var fuerza = parseFloat(img.getAttribute('data-lw-parallax')) || 0;
    if (!fuerza) return;
    var ticking = false;
    window.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function () {
        var r = img.parentElement.getBoundingClientRect();
        var off = (r.top + r.height / 2 - window.innerHeight / 2) * (fuerza / 100) * -0.25;
        img.style.transform = 'scale(1.08) translateY(' + off.toFixed(1) + 'px)';
        ticking = false;
      });
    }, { passive: true });
  }

  function initProducto(root) {
    var pp = (root || document).querySelector('[data-lw-producto]');
    if (!pp || pp.dataset.lwOk) return;
    pp.dataset.lwOk = '1';

    // Galería
    var principal = pp.querySelector('[data-lw-principal]');
    pp.querySelectorAll('[data-lw-mini]').forEach(function (b) {
      b.addEventListener('click', function () {
        if (!principal) return;
        principal.style.opacity = '0';
        setTimeout(function () {
          principal.src = b.getAttribute('data-src');
          principal.srcset = '';
          principal.alt = b.getAttribute('data-alt') || '';
          principal.style.opacity = '1';
        }, 150);
        pp.querySelectorAll('[data-lw-mini]').forEach(function (o) { o.setAttribute('aria-current', 'false'); });
        b.setAttribute('aria-current', 'true');
      });
    });

    // Cantidad
    var cant = pp.querySelector('[data-lw-cantidad]');
    pp.querySelectorAll('[data-lw-cant]').forEach(function (b) {
      b.addEventListener('click', function () {
        if (!cant) return;
        var v = parseInt(cant.value, 10) || 1;
        v = Math.max(1, v + parseInt(b.getAttribute('data-lw-cant'), 10));
        cant.value = v;
      });
    });

    var idInput = pp.querySelector('input[name=id]');
    var precio = pp.querySelector('[data-lw-precio]');
    var moneda = pp.getAttribute('data-lw-moneda') || 'EUR';
    var locale = document.documentElement.lang || 'es';
    var formato = pp.getAttribute('data-lw-formato');
    function fmt(c) {
      // Mismo formato que el filtro money de Shopify (p. ej. "€{{amount_with_comma_separator}}")
      if (formato) {
        var conPuntos = (c / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
        var valores = {
          amount: conPuntos,
          amount_no_decimals: Math.round(c / 100).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ','),
          amount_with_comma_separator: (c / 100).toFixed(2).replace('.', ',').replace(/\B(?=(\d{3})+(?!\d))/g, '.'),
          amount_no_decimals_with_comma_separator: Math.round(c / 100).toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.')
        };
        return formato.replace(/\{\{\s*(\w+)\s*\}\}/, function (m, clave) { return valores[clave] !== undefined ? valores[clave] : conPuntos; });
      }
      try { return new Intl.NumberFormat(locale, { style: 'currency', currency: moneda }).format(c / 100); }
      catch (e) { return (c / 100).toFixed(2); }
    }

    // Cuenta atrás hasta el final del día límite (hora de España, 23:59:59 CET = 22:59:59 UTC); al pasar, se oculta
    var cuenta = pp.querySelector('[data-lw-cuenta]');
    if (cuenta) {
      var limite = Date.parse(cuenta.getAttribute('data-lw-cuenta') + 'T22:59:59Z');
      var pintar = function () {
        var s = Math.floor((limite - Date.now()) / 1000);
        if (!(s > 0)) { cuenta.hidden = true; return false; }
        cuenta.querySelector('[data-lw-cuenta-d]').textContent = Math.floor(s / 86400);
        cuenta.querySelector('[data-lw-cuenta-h]').textContent = Math.floor(s % 86400 / 3600);
        cuenta.querySelector('[data-lw-cuenta-m]').textContent = String(Math.floor(s % 3600 / 60)).padStart(2, '0');
        cuenta.hidden = false;
        return true;
      };
      if (pintar()) setInterval(pintar, 30000);
    }

    // Extra: al marcar la casilla se compra el pack (producto + llavero) con el modelo elegido
    var extra = pp.querySelector('[data-lw-extra]');
    if (extra && idInput) {
      var check = extra.querySelector('[data-lw-extra-check]');
      var sel = extra.querySelector('[data-lw-extra-select]');
      var modelos = extra.querySelector('[data-lw-extra-modelos]');
      var foto = extra.querySelector('[data-lw-extra-img]');
      var aplicarExtra = function () {
        var op = sel.options[sel.selectedIndex];
        modelos.hidden = !check.checked;
        idInput.value = check.checked ? sel.value : extra.getAttribute('data-base');
        if (precio) precio.textContent = fmt(parseInt(check.checked ? op.getAttribute('data-precio') : extra.getAttribute('data-base-precio'), 10));
        if (foto && op.getAttribute('data-img')) foto.src = op.getAttribute('data-img');
      };
      check.addEventListener('change', aplicarExtra);
      sel.addEventListener('change', aplicarExtra);
      if (check.checked) aplicarExtra();
    }

    // Pack de unidades: añade al carrito cada modelo elegido y abre el carrito
    var pack = pp.querySelector('[data-lw-pack]');
    if (pack) {
      pack.querySelectorAll('[data-lw-pack-select]').forEach(function (s) {
        s.addEventListener('change', function () {
          var img = s.parentNode.querySelector('[data-lw-pack-img]');
          var src = s.options[s.selectedIndex].getAttribute('data-img');
          if (img && src) img.src = src;
        });
      });
      pack.querySelector('[data-lw-pack-boton]').addEventListener('click', function () {
        var b = this, cuenta = {};
        pack.querySelectorAll('[data-lw-pack-select]').forEach(function (s) { cuenta[s.value] = (cuenta[s.value] || 0) + 1; });
        var items = Object.keys(cuenta).map(function (id) { return { id: parseInt(id, 10), quantity: cuenta[id] }; });
        b.disabled = true;
        fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart/add.js', {
          method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: items })
        }).then(function (r) {
          if (!r.ok) throw new Error();
          location.href = (window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart';
        }).catch(function () {
          b.disabled = false;
          pack.querySelector('[data-lw-pack-error]').hidden = false;
        });
      });
    }

    // Variantes
    var datos = pp.querySelector('[data-lw-variantes]');
    if (!datos) return;
    var variantes = JSON.parse(datos.textContent);
    var tachado = pp.querySelector('[data-lw-tachado]');
    var boton = pp.querySelector('[data-lw-boton]');
    var agotado = pp.querySelector('[data-lw-agotado]');
    function actualizar() {
      var sel = [];
      pp.querySelectorAll('[data-lw-opcion]').forEach(function (fs) {
        var c = fs.querySelector('input:checked');
        sel[parseInt(fs.getAttribute('data-lw-opcion'), 10)] = c ? c.value : null;
      });
      var v = variantes.find(function (x) {
        return x.options.every(function (o, i) { return sel[i] == null || sel[i] === o; });
      });
      if (!v) return;
      idInput.value = v.id;
      if (precio) precio.textContent = fmt(v.price);
      if (tachado) {
        if (v.compare_at_price && v.compare_at_price > v.price) { tachado.textContent = fmt(v.compare_at_price); tachado.hidden = false; }
        else tachado.hidden = true;
      }
      if (v.img && principal) { principal.src = v.img; principal.srcset = ''; }
      if (boton) boton.disabled = !v.available;
      if (agotado) agotado.classList.toggle('lw-on', !v.available);
    }
    pp.querySelectorAll('[data-lw-opcion] input').forEach(function (i) { i.addEventListener('change', actualizar); });
  }

  // Barra fija de compra: aparece cuando el botón principal sale de la pantalla
  function initBarra(root) {
    (root || document).querySelectorAll('[data-lw-barra]').forEach(function (barra) {
      if (barra.dataset.lwOk) return;
      barra.dataset.lwOk = '1';
      var pp = barra.closest('[data-lw-producto]');
      var boton = pp && pp.querySelector('[data-lw-boton]');
      if (!boton || !('IntersectionObserver' in window)) return;
      var precio = pp.querySelector('[data-lw-precio]');
      var precioBarra = barra.querySelector('[data-lw-barra-precio]');
      new IntersectionObserver(function (ent) {
        // En el móvil la barra sale siempre que el botón principal no se vea (también antes de llegar a él)
        var movil = window.innerWidth < 750;
        var fuera = !ent[0].isIntersecting && (movil || ent[0].boundingClientRect.top < 0);
        if (fuera && precio && precioBarra) precioBarra.textContent = precio.textContent;
        barra.classList.toggle('lw-on', fuera);
      }).observe(boton);
      barra.querySelector('[data-lw-barra-boton]').addEventListener('click', function () {
        if (boton.disabled) { boton.scrollIntoView({ behavior: 'smooth', block: 'center' }); return; }
        boton.click();
      });
    });
  }

  function initTodo(root) {
    initBarra(root);
    initContadores(root);
    initReveal(root);
    initComparador(root);
    initParallax(root);
    initProducto(root);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initTodo(); });
  else initTodo();

  // Selector de versiones: cada versión es otro producto, se abre su página
  document.addEventListener('change', function (e) {
    var r = e.target.closest('[data-lw-version]');
    if (r && r.checked && r.dataset.url && location.pathname !== r.dataset.url) location.href = r.dataset.url + '#comprar';
  });

  // Club: botón "Copiar" del código de descuento
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-lw-copiar]');
    if (!b) return;
    var cod = b.parentNode.querySelector('[data-lw-codigo]');
    if (!cod || !navigator.clipboard) return;
    navigator.clipboard.writeText(cod.textContent.trim()).then(function () {
      var t = b.textContent; b.textContent = b.getAttribute('data-copiado');
      setTimeout(function () { b.textContent = t; }, 2000);
    });
  });
  // Club: tras apuntarse, lleva al cliente a ver su código
  if (/customer_posted=true/.test(location.search)) {
    window.addEventListener('load', function () {
      var ok = document.querySelector('.lw-club__ok');
      if (ok) ok.scrollIntoView({ block: 'center' });
    });
  }

  // Editor de Shopify: reinicia al editar una sección
  document.addEventListener('shopify:section:load', function (e) { initTodo(e.target); });
})();
